<template>
  <primary-confirm-dialog
    :value="value"
    :loading="loading"
    max-width="608px"
    cancel-text="Вернуться назад"
    @input="$emit('input', $event)"
    @close="$emit('close')"
  >
    <template #title>
      <template v-if="displayRemoving">
        Снять филиал со стопа?
      </template>
      <template v-else>
        Поставить филиал в стоп?
      </template>
    </template>

    <template #subtitle>
      <template v-if="displayRemoving">
        Блюда снова станут доступны для заказа
        <b>на сайте, в приложении и ЦРМ</b>. Индивидуальные стопы блюд останутся.
      </template>
      <template v-else>
        Все блюда филиала встанут на стоп, приём заказов остановится
        <b>на сайте, в приложении и ЦРМ</b>.
      </template>
    </template>

    <template #body>
      <!-- Инфо-плашка в стиле settings-scope-hint (настройки методов оплаты) -->
      <div class="filial-stop-dialog_aggregators-hint">
        <font-awesome-icon icon="info-circle" class="hint-icon" />
        <span v-if="displayRemoving">
          Не забудьте в личных кабинетах агрегаторов включить приём заказов
          в ваш ресторан.
        </span>
        <span v-else>
          Не забудьте в личных кабинетах агрегаторов выключить приём заказов
          в ваш ресторан.
        </span>
      </div>

      <template v-if="!displayRemoving">
        <enum-value-select-field
          v-model="reason"
          label="Причина"
          :enum-class="getReasonEnumClass()"
        />

        <v-textarea
          v-if="isOtherReason"
          v-model="reasonComment"
          label="Укажите причину"
          rows="3"
          outlined
          counter="500"
          maxlength="500"
        />
      </template>
    </template>

    <template #confirm-btn>
      <large-btn
        color="#ff005f"
        class="primary-confirm-dialog_btn primary-confirm-dialog_btn__confirm"
        height="64px"
        :uppercase="false"
        :loading="loading"
        :disabled="!isValid"
        block
        @click="confirm"
      >
        <!-- Та же пара, что у кнопки на странице: ладонь - стоп, play - снова принимать заказы -->
        <font-awesome-icon
          :icon="displayRemoving ? 'play' : 'hand-paper'"
          class="filial-stop-dialog_btn-icon"
        />
        {{ displayRemoving ? 'Снять филиал со стопа' : 'Поставить филиал в стоп' }}
      </large-btn>
    </template>
  </primary-confirm-dialog>
</template>

<script>
  import LargeBtn from '@/components/ui/buttons/LargeBtn.vue'
  import PrimaryConfirmDialog from '@/components/ui/dialogs/PrimaryConfirmDialog.vue'
  import EnumValueSelectField from '@/components/ui/crud/fields/EnumValueSelectField.vue'
  import FilialStopReason from '@/models/enums/FilialStopReason'

  export default {
    name: 'FilialStopDialog',
    components: { PrimaryConfirmDialog, EnumValueSelectField, LargeBtn },
    emits: ['confirm', 'close', 'input'],
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      // true - диалог снятия со стопа, false - постановки
      removing: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        // Снапшот removing на момент открытия. Проп привязан к живому стору:
        // после успешного запроса store переворачивается раньше, чем диалог
        // закроется (плюс транзишн закрытия), и без снапшота контент на
        // мгновение перещёлкивался в противоположный режим
        displayRemoving: this.removing,
        reason: null,
        reasonComment: '',
      }
    },
    computed: {
      isOtherReason () {
        return this.reason === FilialStopReason.Other
      },

      isValid () {
        if (this.displayRemoving) {
          return true
        }

        if (!this.reason) {
          return false
        }

        return !this.isOtherReason || !!this.reasonComment.trim()
      },
    },
    watch: {
      value (val) {
        if (val) {
          this.displayRemoving = this.removing
          this.reason = null
          this.reasonComment = ''
        }
      },
    },
    methods: {
      getReasonEnumClass () {
        return FilialStopReason
      },

      confirm () {
        if (this.displayRemoving) {
          this.$emit('confirm', null)
          return
        }

        this.$emit('confirm', {
          reason: this.reason,
          reasonComment: this.isOtherReason ? this.reasonComment.trim() : null,
        })
      },
    },
  }
</script>

<style lang="less" scoped>
// Вёрстка и палитра - как у settings-scope-hint в настройках методов оплаты
.filial-stop-dialog_aggregators-hint {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 20px;
  padding: 12px 16px;
  background: linear-gradient(105deg, #fff9f0 0%, #ffefdb 100%);
  border-radius: 8px;
  font-size: 14px;
  line-height: 1.5;
  color: #191919;

  .hint-icon {
    flex-shrink: 0;
    margin-top: 3px;
    font-size: 16px;
    .fill-svg(@color-primary);
  }
}

</style>

<style lang="less">
// Не scoped: окно рендерится вне корня компонента, а глобальное правило
// PrimaryConfirmDialog (.primary-confirm-dialog_btn__confirm svg 40x28)
// перебивает scoped-размеры. Класс уникальный - наружу не течёт
.primary-confirm-dialog .primary-confirm-dialog_btn__confirm svg.filial-stop-dialog_btn-icon {
  width: 20px;
  height: 20px;
  margin-right: 10px;
  flex: 0 0 auto;
}
</style>
